// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LrQg3","full":"styles_full__tV6O9"};